import { cm } from '~/utils/utils'

interface IconProps {
  className?: string
  size?: number
}

export function MavenIcon({ className, size = 18 }: IconProps) {
  return (
    <img
      src='/icons/maven-icon.png'
      alt='Maven'
      width={size}
      height={size}
      className={cm('pointer-events-none', className)}
    />
  )
}

export function JavaIcon({ className, size = 18 }: IconProps) {
  return (
    <img
      src='/icons/java-icon.png'
      alt='Java'
      width={size}
      height={size}
      className={cm('pointer-events-none', className)}
    />
  )
}

export function MuleIcon({ className, size = 18 }: IconProps) {
  return (
    <img
      src='/icons/mule-icon.png'
      alt='Mule'
      width={size}
      height={size}
      className={cm('pointer-events-none', className)}
    />
  )
}
